import { Dialog, DialogContent } from '@wellesley/ui'
import { useDispatch, useSelector } from 'react-redux'
import { authSlice } from '../../../authSlice'
import { LoginForm } from '../LoginForm'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const AskLoginModal = () => {
  const isAskLoginOpen = useSelector(authSlice.selectors.selectAskLoginOpen)
  const isLogged = useSelector(authSlice.selectors.selectIsAuthenticated)
  const location = useLocation()
  const dispatch = useDispatch()
  const handleOpenChange = (open: boolean) => {
    dispatch(authSlice.actions.setAskLoginOpen(open))
  }

  useEffect(() => {
    if (isLogged) {
      handleOpenChange(false)
    }
  }, [isLogged])

  useEffect(() => {
    handleOpenChange(false)
  }, [location.pathname])

  return (
    <Dialog open={isAskLoginOpen} onOpenChange={handleOpenChange}>
      <DialogContent title="Sign in to continue">
        <LoginForm
          signupRedirectUrl={location.pathname}
          description="To interact with Wellesley, you need to sign in to your account"
        />
      </DialogContent>
    </Dialog>
  )
}
